<script lang="ts" setup></script>

<template>
  <svg
    fill="none"
    height="24"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.5"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 18h20" />
    <path d="M5 18a7 7 0 0 1 14 0" stroke-dasharray="2 2" />
    <path d="M12 8v3" />
    <path d="m4.9 13 1.4-1.4" />
    <path d="m17.7 11.6 1.4 1.4" />
    <path d="m9 5 3 3 3-3" />
  </svg>
</template>
